import SEO from '../components/SEO';
import BlogList from '../components/BlogList';

export default function BlogIndexPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "JsonToonCraft Blog",
    "description": "Developer insights, tutorials, and best practices for JSON conversion, LLM optimization, and developer productivity.",
    "url": "https://jsontooncraft.com/blog",
    "publisher": {
      "@type": "Organization",
      "name": "JsonToonCraft",
      "logo": {
        "@type": "ImageObject",
        "url": "https://jsontooncraft.com/og-image.png"
      }
    }
  };

  return (
    <>
      <SEO
        title="Blog - Developer Insights & Guides | JsonToonCraft"
        description="Tips, tutorials, and best practices for modern development. Learn about JSON conversion, TOON format, LLM optimization, and developer productivity tools."
        keywords="developer blog, JSON tutorial, TOON format guide, LLM optimization, TypeScript tips, Zod schema, developer tools, coding best practices"
        canonicalUrl="https://jsontooncraft.com/blog"
        ogType="website"
        structuredData={structuredData}
      />
      <BlogList />
    </>
  );
}
